import {MenuItemsConfiguration} from "../configurations/config-data-sections/menu-items.configuration";
import {MenuItemConfigReaderBase} from "../menu-items-common/menu-item-config-reader/menu-item-config-reader-base";
import {
    MenuItemAnalyticsCategoryAndLabel
} from "../menu-items-common/menu-item-config-reader/menu-item-config-reader.interface";
import {OrbitUserFlowAnalyticsCategory, OrbitUserFlowAnalyticsLabel} from "../analytics/analytics.service.interface";


export class CrossBrandsMenuItemConfigReader extends MenuItemConfigReaderBase {

    protected _getMenuItemsConfigOverrides(): MenuItemsConfiguration | undefined {
        return this.services.configuration.data.header.menuItemsOverride;
    }

    protected _getAnalyticsCategoryAndLabel(): MenuItemAnalyticsCategoryAndLabel {
        return {
            category: OrbitUserFlowAnalyticsCategory.Navigation,
            label: OrbitUserFlowAnalyticsLabel.AppHeader
        };
    }
}

